import {
    serializable,
    DynamicFormControlLayout,
    DynamicInputModel,
    DynamicInputModelConfig,
	MATCH_VISIBLE,
	OR_OPERATOR,
} from "@ng-dynamic-forms/core";
import { Model_WorkflowComponent, CODE_WORKFLOW_COMPONENT, TYPE_DATASOURCE, TYPE_DEFAULT_VALUE, TYPE_WORKFLOW_COMPONENT_OBSERVER, EXPRESSION_FIELD_SCOPE, FONCTION_WORKFLOW_COMPONENT_OPTIONS } from 'src/app/app.models';
import { COMPONENT_MODE, COMPONENT_UI } from '../workflow-components.models';
import { WorkflowComponentBuilderOptions } from '../workflow-components.service';
  
export interface InputGridFunctionsModelConfig extends DynamicInputModelConfig {
	componentMode: COMPONENT_MODE;
	inputGridId: string;
	inputGridColumnId: string;
}
  
export class InputGridFunctionsModel extends DynamicInputModel {
	@serializable() readonly type: string = 'input_grid_functions'; 
	componentMode: COMPONENT_MODE;
	componentUI: COMPONENT_UI;
	inputGridId: string;
	inputGridColumnId: string;

	constructor(config: InputGridFunctionsModelConfig, layout?: DynamicFormControlLayout) {
		super(config, layout);
		this.componentMode = config.componentMode;
		this.componentUI = COMPONENT_UI.KENDO;
		this.inputGridId = config.inputGridId;
		this.inputGridColumnId = config.inputGridColumnId;
	}

	static initModel(_component: Model_WorkflowComponent): InputGridFunctionsModel {
		const formModel = new InputGridFunctionsModel({
			id: _component.ID,
			name: _component.ID,
			label: _component.LABEL,
			value: _component.DEFAULT_VALUE,
			required: _component.IS_REQUIRED,
			readOnly: _component.IS_READONLY,
			hidden: _component.IS_VISIBLE !== undefined ? _component.IS_VISIBLE === false : false,
			validators: _component.CUSTOM_VALIDATORS,
			componentMode: _component.COMPONENT_MODE,
			additional: _component,
			relations: _component.RELATIONS,
			inputGridId: (_component as any).INPUT_GRID_ID,
			inputGridColumnId: (_component as any).INPUT_GRID_COLUMN_ID,
		});
		return formModel;
	}

	static getProperties(_options?: WorkflowComponentBuilderOptions): Model_WorkflowComponent {
		const workflowComponents = !!_options && !!_options.workflow ? 
			Array.prototype.concat.apply([], 
				_options.workflow.WORKFLOW_STEPS.filter(step => !!step.COMPONENTS)
				.map(step => step.COMPONENTS.filter(component => component.CODE == CODE_WORKFLOW_COMPONENT.INPUT_GRID)
				.map(component => ({ 
					ID: component.ID, 
					TEXT: `${component.INDEX} - ${component.LABEL} [${component.CODE}]`, 
					NUMWORKFLOW_STEP: step.NUM_WORKFLOWSTEP,
					GRID_COLUMNS: component.GRID_COLUMNS 
				})))) : [];
		return {
			ID: 'input-grid-functions',
			CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID_FUNCTIONS,
			ICON: 'code-download-outline',
			LABEL: 'Aggrégat Grille de saisie',
			PROPERTIES: [
				{ ID: 'GUID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'GUID', IS_VISIBLE: false },
				{ ID: 'INDEX', CODE: CODE_WORKFLOW_COMPONENT.NUMERIC_TEXTBOX, LABEL: 'Index', DEFAULT_VALUE: 1 },
				{ ID: 'ID', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Identifiant', IS_REQUIRED: true, CUSTOM_VALIDATORS: [{ VALIDATOR_NAME: 'no_whitespace' }] },
				{ ID: 'LABEL', CODE: CODE_WORKFLOW_COMPONENT.TEXTBOX, LABEL: 'Libellé', IS_REQUIRED: true },
				{ ID: 'IS_VISIBLE', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Visible ?', DEFAULT_VALUE: true },
				{ ID: 'IS_REQUIRED', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Est Requis ?' },
				{ ID: 'IS_READONLY', CODE: CODE_WORKFLOW_COMPONENT.TOGGLE, LABEL: 'Lecture Seule ?' },
				{ 
					ID: 'INPUT_GRID_ID', 
					CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, 
					LABEL: 'Grille de saisie', 
					IS_REQUIRED: true,
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: workflowComponents,
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'TEXT'
						}
					}
				},
				{ ID: 'INPUT_GRID_FUNCTION_ID', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Fonction', DEFAULT_VALUE: 'SUM', IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [
								{ ID: 'SUM', LABEL: 'Somme' },
								{ ID: 'COUNT', LABEL: 'Compter occurences' },
							],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'LABEL',
						},
					}
				},
				{ 
					ID: 'INPUT_GRID_COLUMN_ID', CODE: CODE_WORKFLOW_COMPONENT.DROPDOWN, LABEL: 'Colonne', DEFAULT_VALUE: null, IS_REQUIRED: true, 
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'LABEL',
						},
						OBSERVERS: [
							{ field: 'INPUT_GRID_ID', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.LIST_GRID_COLUMNS, params: 'GRID_COLUMNS' }
						],
					},
					RELATIONS: [
						{ 
							match: MATCH_VISIBLE, 
							operator: OR_OPERATOR,
							when: [
								{ id: 'INPUT_GRID_FUNCTION_ID', value: 'SUM' },
							] 
						}
					] 
				},
				{ 
					ID: 'INPUT_GRID_FILTERS', 
					CODE: CODE_WORKFLOW_COMPONENT.INPUT_GRID_FILTERS, 
					LABEL: 'Filtre', 
					DEFAULT_VALUE: null, 
					HAS_DATASOURCE: true,
					UIC_PARAMS: {
						DATASOURCE: {
							DATASOURCE_TYPE: TYPE_DATASOURCE.STATIC,
							DATASOURCE_DATAS: [],
							DATASOURCE_VALUE_FIELD: 'ID',
							DATASOURCE_DISPLAY_FIELD: 'LABEL',
						},
						OBSERVERS: [
							{ field: 'INPUT_GRID_ID', type: TYPE_WORKFLOW_COMPONENT_OBSERVER.LIST_GRID_COLUMNS, params: 'GRID_COLUMNS' }
						],
					}
				},
			]
		};
	}
}
  